import type { BlockContent } from 'components/editor/grid/reduxStore/editorSlice';
import { PreviewBlock } from 'components/editor/GridDndEditor/Block/Preview/PreviewBlock';
import EmptyVideoPlaceholder from 'components/editor/GridDndEditor/Block/Video/EmptyVideoPlaceholder';
import { gridPixelSize } from 'components/editor/shared/gridConfig';
import type { VideoContent } from 'components/editor/videos/video';
import VideoEmbed from 'components/editor/videos/videoEmbed';

type Props = {
  block: BlockContent;
  rotation?: number;
};

export const PreviewVideo = ({ block, rotation }: Props) => {
  const { type, videoId, title, author } = block.contentObject as VideoContent;
  const { width, height } = block.blockConfig;

  return (
    <PreviewBlock key={block.blockConfig.id} gridBlock={block} gridSystemInPx={gridPixelSize} rotation={rotation}>
      {videoId ? (
        <VideoEmbed type={type} videoId={videoId} width={width} height={height} title={`${title} by ${author}`} />
      ) : (
        <EmptyVideoPlaceholder dimension={{ width, height }} />
      )}
    </PreviewBlock>
  );
};
